import * as React from 'react'
import { Badge, badges } from '@amzn/dvui/dist/Badge'
import * as badgeSt from './badge.module.scss'
import { AtfTreatmentProps } from '../../reducers/features'
import { isTreatment } from '../../utils/utils'

export interface IReleaseYearBadgeProps extends AtfTreatmentProps {
  releaseYear?: number
}

export const ReleaseYear = ({ releaseYear, atfTreatment }: IReleaseYearBadgeProps) => (
  releaseYear && (
    <Badge use={badges.TEXT}>
      <span {...(isTreatment(atfTreatment,'T1', 'T2', 'T3') && { className: badgeSt.lightBadge})} data-automation-id="release-year-badge">{releaseYear}</span>
    </Badge>) || null
)
